import { useContext, useEffect } from "react";
import { GlobalContext } from "@utils/GlobalContext.js";
import { t } from 'i18next'

export default function Toast() {
  const { toastMsg, setSeeToast, seeToast, errorToast } = useContext(GlobalContext);

  useEffect(() => {
    if (!seeToast) return;

    const timer = setTimeout(() => setSeeToast(false), 5000);
    return () => clearTimeout(timer);
  }, [seeToast, setSeeToast]);

  if (!seeToast) return null;

  return (
    <div
      className={`${errorToast? 'bg-danger':'bg-success'} d-flex align-items-center position-fixed bottom-0 start-0 m-5 p-3 rounded border border-2 border-start border-dark shadow gap-4`}
      style={{ minWidth: "250px", zIndex: 9999}}
    >
      <div className="flex-grow-1 text-white fs-5">
         
        <div className=" d-flex align-items-center gap-2">
          {errorToast?<i className="fa-solid fa-circle-exclamation"></i>:<i className="fa-solid fa-circle-check"></i> }
          <span className="text-uppercase">{errorToast? t("error.error") :t("success.success")}</span> 
        </div>
        {toastMsg}
      </div>
      {/* <i role="button" className="fa-solid fa-xmark fs-3" onClick={() => setSeeToast(false)}></i>   */}
    </div>
  );
}
